require('../scss/levis.scss');

const photoSearch = document.querySelector('#photo-search');

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.filter-designer .select2-selection__placeholder')) {
        document.querySelector('.filter-designer .select2-selection__placeholder').innerText = Translator.transChoice('filters.placeholder.collection');
    }
    if (photoSearch) {
        photoSearch.classList.add('liveinlevis');
    }
    if (document.querySelector('.list-designers-container')) {
        initHomepageBanner();
        initSortGridHomepage();
    }
    if (document.querySelector('#photo-search #no-results') &&
        document.querySelector('.page-title') &&
        document.querySelector('.page-title-content')
    ) {
        document.querySelector('.page-title-content').style.paddingBottom = window.innerWidth >= 768 ? '2rem' : '.75rem';
    }
});

/**
 * sorts homepage designer with common labels and inserts labels as categories
 */
const initSortGridHomepage = () => {
    const cards = Array.from(document.querySelectorAll('.photo-card')).reverse();
    const photoList = document.querySelector('.photo-list');
    let labels = [];
    cards.map(card => {
        let label;
        if (card.dataset.category.length >= 1) {
            label = card.dataset.category;
        } else {
            label = 'OTHERS';
            card.dataset.category = label;
        }
        const category = document.querySelector(`.category[data-category="${label}"]`);
        if (category === null) {
            const categoryHTML = `<div class="category" data-category="${label}"><div class="content"><span class="title">${label}</span></div></div>`;
            photoList.insertAdjacentHTML('afterbegin', categoryHTML);
        }
        photoList.insertBefore(card, document.querySelector(`.category[data-category="${label}"]`).nextElementSibling);
        labels.indexOf(label) === -1 ? labels.push(label) : '';
    });
    if (window.innerWidth >= 576) {
        labels.map(label => calcRemainingSpacePerRow(label));
    }
};

/**
 * Calculates the margin right percentages of items on a row to break line for next category
 * @param {String} label
 */
const calcRemainingSpacePerRow = (label) => {
    const totalElements = Array.from(document.querySelectorAll(`[data-category="${label}"]`));
    const elementsPerRow = window.innerWidth >= 992 ? 5 : window.innerWidth >= 768 ? 3 : 2;
    let remainingSpace;
    //+1 cause categories elements counts for two elements
    const remainingElement = (totalElements.length + 1) % elementsPerRow;
    if (remainingElement !== 0) {
        remainingSpace = 100 - ((totalElements.length + 1) % elementsPerRow) * (100 / elementsPerRow);
        totalElements[totalElements.length - 1].style.setProperty('margin-right', `${remainingSpace}%`, 'important');
    }
};

const initHomepageBanner = () => {
    const homepage = document.querySelector('.homepage-banner');
    const welcomeHeader = `<h1 class="welcome-header">${Translator.trans('homepage.welcome_pr', {'showroom': 'levi\'s®'})}</h1>`
    const imgs = `
        <ul class="icons">
            <li><img src="https://cdn.tag-walk.com/showroom/levis/FW21/icon-1.png" alt="Levis icons"></li>
            <li><img src="https://cdn.tag-walk.com/showroom/levis/FW21/icon-2.png" alt="Levis icons"></li>
            <li><img src="https://cdn.tag-walk.com/showroom/levis/FW21/icon-3.png" alt="Levis icons"></li>
            <li><img src="https://cdn.tag-walk.com/showroom/levis/FW21/icon-4.png" alt="Levis icons"></li>
            <li><img src="https://cdn.tag-walk.com/showroom/levis/FW21/icon-5.png" alt="Levis icons"></li>
            <li><img src="https://cdn.tag-walk.com/showroom/levis/FW21/icon-6.png" alt="Levis icons"></li>
        </ul>
    `

    document.querySelector('#content').insertAdjacentHTML('beforebegin', welcomeHeader);
    homepage.insertAdjacentHTML('afterbegin', imgs);
}
